(ns frontend.view.modals.sales-opportunity-stage-delete.view
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.actions.sales-opportunity-stages :as sales-opportunity-stage-actions]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.modals.components.processing-modal :as processing-modal]
   [ui.color :as c]
   [ui.components.input.checkbox :as checkbox]
   [ui.components.modal.view :as modal]
   [ui.editors.data-input :as data-input]))

(defonce modal-key :sales-opportunity-stage-delete-modal)

(defn update!
  [state k val]
  (swap! state assoc-in [:edit k] val))

(defn select-sales-opportunity-stage-view
  [state sales-opportunity-stage]
  (let [pipeline-id (:sales-opportunity-stage/pipeline sales-opportunity-stage)
        sales-opportunity-stages (->> @session/sales-opportunity-stages
                                      (remove (fn [s]
                                                (= s sales-opportunity-stage)))
                                      (cu/filter-by :sales-opportunity-stage/pipeline pipeline-id)
                                      (sort-by :common/ord))
        value (get-in @state [:edit :new-sales-opportunity-stage])
        error (when (and (:touched? @state)
                         (fu/empty-value? value))
                (loc/tr :mandatory-field/value-not-set [(loc/tr :stage)]))]
    [:div
     [data-input/view
      {:editor-type   :editor.type/select
       :data-type     :data.type/ref-single
       :is-clearable? false
       :full-width?   true
       :value         value
       :error         error
       :options       (->> sales-opportunity-stages
                           (map (fn [a]
                                  {:value (:db/id a)
                                   :label (entity/display-string a)})))
       :on-blur       (fn [_] (swap! state assoc :touched? true))
       :on-change     (fn [new-value & _]
                        (swap! state assoc :touched? true)
                        (update! state :new-sales-opportunity-stage new-value))}]
     (when error
       [:p {:class "text-xs text-danger-light-text"} error])]))

(defn view-body
  [state sales-opportunity-stage-id]
  (let [sales-opportunity-stage (get @session/entities sales-opportunity-stage-id)
        reassignment-required? (:reassignment/required? @state)]
    [:div
     {:class "flex flex-col gap-4"}
     (when reassignment-required?
       [:div
        {:class "flex flex-col gap-4"}
        [:span {:class "font-semibold"}
         (loc/tr :sales-opportunity-stage-select-new
                 [(:reassignment/count @state)
                  (:sales-opportunity-stage/name sales-opportunity-stage)])]
        [select-sales-opportunity-stage-view state sales-opportunity-stage]])
     [:label
      {:class "inline-flex flex items-center gap-2 cursor-pointer"}
      [checkbox/view
       {:value  (-> @state
                    :confirmed?
                    boolean)
        :on-change #(swap! state update :confirmed? not)}]
      [:span
       (loc/tr :i-understand-theres-no-undo-for-this)]]]))

(defn handle-delete-error!
  [state e]
  (if (= :stage-reassignment-required
         (get-in e [:client-friendly-error-data :reason]))
    (swap! state (fn [s]
                   (-> s
                       (assoc :reassignment/required? true)
                       (assoc :reassignment/count
                              (get-in e [:client-friendly-error-data :count]))
                       (dissoc :process/status))))
    (do
      (logging/error "failed to delete sales-opportunity-stage" e)
      (swap! state assoc :process/status :process.status/failed))))

(defn delete!
  [state sales-opportunity-stage-id on-close!]
  (let [new-sales-opportunity-stage-id (-> @state
                                           :edit
                                           :new-sales-opportunity-stage)
        msg (cond-> {:sales-opportunity-stage-id sales-opportunity-stage-id}
              new-sales-opportunity-stage-id
              (assoc :new-sales-opportunity-stage-id new-sales-opportunity-stage-id))]
    (swap! state assoc :process/status :process.status/processing)
    (sales-opportunity-stage-actions/*->disable
     msg
     (fn [_]
       (js/setTimeout (fn []
                        (swap! state assoc :process/status :process.status/success))
                      2000))
     (fn [e]
       (handle-delete-error! state e)))))

(defn footer-view
  [{:keys [disabled? state on-close! sales-opportunity-stage]}]
  [:<>
   [modal/left-cancel-only on-close! nil]
   [modal/right-single-button
    ::c/danger
    disabled?
    (fn [e]
      (delete! state (:db/id sales-opportunity-stage) on-close!))
    (loc/tr :delete)
    nil]])

(defn view
  [{:keys [close-modal!] :as view-args}]
  (let [on-close! (fn []
                    (close-modal!))]
    (fn [{:keys [shown? close-modal! props state class-name topmost?]}]
      (let [{:keys [body sales-opportunity-stage-id]} props
            confirmed? (-> @state
                           :confirmed?
                           boolean)
            new-sales-opportunity-stage (->> @state
                                             :edit
                                             :new-sales-opportunity-stage
                                             (get @session/entities))
            disabled? (or (not confirmed?)
                          (and (:reassignment/required? @state)
                               (or (nil? new-sales-opportunity-stage)
                                   (:common/disabled? new-sales-opportunity-stage))))
            sales-opportunity-stage (get @session/entities sales-opportunity-stage-id)]
        [processing-modal/render-modal
         {:state             state
          :shown?            (and shown? topmost?)
          :success-text      (loc/tr :success-sales-opportunity-stage-deleted)
          :on-close!         on-close!
          :class-name        class-name
          :header-class-name "zap-modal__header__salmon"
          :default-title-fn  #(loc/tr :attention)
          :default-body-fn   (partial view-body state sales-opportunity-stage-id)
          :default-footer-fn (partial footer-view
                                      {:disabled?               disabled?
                                       :state                   state
                                       :on-close!               on-close!
                                       :sales-opportunity-stage sales-opportunity-stage})}]))))
